import React, {useEffect} from 'react';
import '@/App.css';
import {BrowserRouter, Routes, Route, Navigate, Outlet, useParams} from 'react-router-dom';
import Layout from '@/components/Layout';
import Selector from '@/pages/Selector';
import Projection from '@/pages/Projection';
import Library from '@/pages/Library';
import {Toaster} from '@/components/ui/sonner';
import {I18nProvider, useTranslation} from '@/lib/i18n';
import SymbolEditor from '@/pages/SymbolEditor';


function LocaleLayout() {
  const {lang} = useParams();
  const {language, setLanguage, supportedLanguages} = useTranslation();
  const valid = supportedLanguages.some((l) => l.code === lang);

  useEffect(() => {
    if (valid && language !== lang) setLanguage(lang);
  }, [valid, lang, language, setLanguage]);
  if (!valid) return <Navigate to={`/${language}`} replace/>;

  return <Layout><Outlet/></Layout>;
}


function RootRedirect() {
  const {language} = useTranslation();
  return <Navigate to={`/${language}/selector`} replace/>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <Routes>
            <Route path="/" element={<RootRedirect/>}/>
            <Route path="/:lang" element={<LocaleLayout/>}>
              <Route index element={<Navigate to="selector" replace/>}/>
              <Route path="selector" element={<Selector/>}/>
              <Route path="svg-editor" element={<SymbolEditor/>}/>
              <Route path="svg-editor/:designId" element={<SymbolEditor/>}/>
              <Route path="projection" element={<Projection/>}/>
              <Route path="library" element={<Library/>}/>
            </Route>
            <Route path="*" element={<RootRedirect/>}/>
          </Routes>

          <Toaster theme="dark"/>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
